import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { API_BASE } from '../../callApi'

export const collection = 'registrations'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi) =>
  (_: unknown, { emailAddress }: { emailAddress: string }) =>
    callApi(`${API_BASE}/registrations`, schema, {
      method: 'POST',
      body: { emailAddress },
    })

export const fetch =
  (callApi: CallApi) =>
  ({ code }: { code: string }) =>
    callApi(`${API_BASE}/registrations/${code}`, schema)
